import { BPButton } from "@/components/bp/bpbutton";
import React from "react";
import { Button, Segment, Form as SForm, FormGroup as SFormGroup, FormField as SFormField } from "@/components/bp/bp-ui";

export function RemovableSegment({ children, remove, disabled }) {
    return (
        <Segment style={{ position: 'relative' }}>
            <SFormGroup widths="equal" style={{ position: 'absolute', zIndex: 1, right: 0, top: 0 }}>
                <SFormField>
                    {!disabled && <BPButton floated='right'
                        disabled={disabled}
                        icon="x"
                        color="red"
                        inverted
                        type="button"
                        size='tiny'
                        onClick={() => remove()}
                        style={{ padding: 5, margin: 5 }}
                    />}
                </SFormField>
            </SFormGroup>
            {children}
        </Segment>
    );
}
